export default "<p>dashboard-v2 works!</p>\n";